import { VehicleFilters } from "../features/Filters/VehicleFilters";

export const ArchivedVehiclesActions = () => {
  return (
    <div className="mt-1">
      <VehicleFilters.ActiveFilters />
    </div>
  );
};
